export default {
  specialization: `profile/specialization`,
  updateSpecialization: `profile/specialization/update`,
};
